module.exports = __webpack_public_path__ + "img/6_Viaduct_Bridge-01.6308bc26.png";